import { useEffect, useState } from "react"
import bankAccountsService from "../../services/bankAccountsService";
import useUser from "../user/useUser";

export const useBankAccounts = (defaultFilters) => {
    const [bankAccounts, setBankAccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const { business } = useUser();        
    const [filters, setFilters] = useState({
        ...defaultFilters,
        pageSize: 100, 
        pageNumber: 1
    });
    
    useEffect(() => {        
        const SearchAllBankAccounts = async () => {
            setLoading(true);
            await bankAccountsService
                .Search(filters) 
                .then(res => {
                    setBankAccounts(res);
                })
                .finally(() => setLoading(false));
        }
        
        if(filters?.businessId > 0)
            SearchAllBankAccounts();
    }, [filters]);

    useEffect(() => {
        if(business?.id > 0)         
            setFilters(state => ({ ...state, businessId: business.id }));        
    }, [business]);

    return { 
        bankAccounts,
        loading,
        
        setFilters
    }
}